import {
  SHOP_ALL_GET, SHOP_ALL_GET_SUCCESS, SHOP_ALL_GET_FAILURE
} from './mutation-types'

export default {
  state: {
    shopsAll: []
  },
  getters: {
    shopsAll: state => {
      return state.shopsAll
    }
  },
  actions: {
    [SHOP_ALL_GET] ({dispatch, state, commit}, params = null) {
      var data = {}
      dispatch('apiGet', {url: '/master/shops/all_get', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_ALL_GET_FAILURE, res.data)
          } else {
            commit(SHOP_ALL_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_ALL_GET_FAILURE] (state, data) {
      console.log('SHOP_ALL_GET_FAILURE')
    },
    [SHOP_ALL_GET_SUCCESS] (state, data) {
      console.log('SHOP_ALL_GET_SUCCESS')
      state.shopsAll = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop.js